module.exports = __webpack_public_path__ + "static/img/Bachelor_010661.2ee2601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010661.jpg
// module id = 206
// module chunks = 0